module.exports = __webpack_public_path__ + "img/levelup-icon-o.ff3d43a7.svg";